import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  zIndex?: number;
  fullScreenMobile?: boolean;
}

const Modal: React.FC<ModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  zIndex = 50, 
  fullScreenMobile = false 
}) => {
  
  // Close on Escape key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 flex items-center justify-center bg-slate-950/80 backdrop-blur-sm p-4"
      style={{ zIndex: zIndex }} 
    >
      <div className={`
        bg-slate-900 shadow-2xl w-full overflow-hidden border border-slate-700 flex flex-col
        ${fullScreenMobile ? 'h-full md:h-auto md:max-h-[90vh] md:rounded-xl md:max-w-md fixed inset-0 md:relative' : 'max-h-[90vh] rounded-xl max-w-md'}
      `}>
        <div className="bg-slate-800 p-4 border-b border-slate-700 flex justify-between items-center sticky top-0 z-10 shrink-0">
          <h3 className="font-serif text-xl text-slate-100 truncate pr-4">{title}</h3>
          <button onClick={onClose} className="text-slate-400 hover:text-white transition-colors p-1 bg-slate-700/50 rounded-full">
            <X size={20} />
          </button>
        </div>
        <div className="p-6 text-slate-200 overflow-y-auto custom-scrollbar flex-grow">
            {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
